import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import CookieStatement from "@/pages/CookieStatement";

export const Route = createFileRoute("/es/declaracion-de-cookies")({
  head: () => buildRouteHead("/es/declaracion-de-cookies"),
  component: CookieStatement,
});

